import React from 'react';
export function FooterSection() {
  return <footer className="border-t border-gray-900 py-12 px-6 text-center" data-id="element-122">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-123">
        <p className="font-serif text-gray-500 text-sm" data-id="element-124">
          © {new Date().getFullYear()} Micro-Automatización Blueprint. Todos
          los derechos reservados.
        </p>
        <div className="flex justify-center space-x-6 text-xs font-sans text-gray-600" data-id="element-125">
          <a href="#" className="hover:text-[#d4a853] transition-colors" data-id="element-126">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#d4a853] transition-colors" data-id="element-127">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}